import { Slide } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import { forwardRef, type ReactElement } from 'react';

export const SlideUpTransition = forwardRef(function SlideUpTransition(
  props: TransitionProps & { children: ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
